import React from 'react';
import { PropTypes } from 'prop-types';
import { useFeatureFlag } from 'common/hooks';
import { AssignToUserWidget } from 'common/utils/Workqueue/AssignToUserWidget';
import { useAssigneeOptions, REQUEST_UNASSIGNED } from 'common/utils/Workqueue/hooks/useAssigneeOptions';
import { useUpdateEnrollmentRequest } from '../hooks/useUpdateEnrollmentRequest';

const AssignUserToEnrollment = ({ enrollmentRequest }) => {
  const paysEwqUserAssignment = useFeatureFlag('pays-ewq-user-assignment');
  const updateEnrollmentRequest = useUpdateEnrollmentRequest();

  const handleAssignmentChange = async (assigneeId) => {
    await updateEnrollmentRequest(
      enrollmentRequest.id,
      { assignee: assigneeId === REQUEST_UNASSIGNED ? null : assigneeId },
      assigneeId === REQUEST_UNASSIGNED ? 'Request successfully unassigned' : 'Request successfully assigned',
    );
  };

  const assigneeOptions = useAssigneeOptions('enrollments', paysEwqUserAssignment);

  if (!paysEwqUserAssignment) {
    return null;
  }

  return (
    <AssignToUserWidget
      assigneeOptions={assigneeOptions}
      currentAssigneeId={enrollmentRequest.assignee?.id}
      onAssignmentChange={handleAssignmentChange}
    />
  );
};

AssignUserToEnrollment.propTypes = {
  enrollmentRequest: PropTypes.shape({
    id: PropTypes.string.isRequired,
    assignee: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
};

export default AssignUserToEnrollment;
